// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"348":"chat","353":"agents","845":"profile"}[chunkId] + "." + {"348":"f458e015","353":"0f1de569","845":"4511b07a"}[chunkId] + ".css";
};